export const getModalType = state => state.modal.get('type')
export const getModalProps = state => state.modal.get('props')

export const getIsOpened = state => {
  const type = getModalType(state)
  const props = getModalProps(state)

  return type && props !== null
}
